<template>
  <div>
    <!--添加条形码-->
    <Form>
      <FormItem v-for="(item, index) in barCodeList" :key="index">
        <Row>
          <Col span="5">{{item.colorname}} - {{item.sizename}}</Col>
          <Col span="14">
            <Input v-model="item.dataCode" @on-keyup="changeBarcode(item)"></Input>
          </Col>
          <Col span="2" offset="1">
            <Button type="primary">
              <Icon type="md-qr-scanner" />
            </Button>
          </Col>
        </Row>
      </FormItem>
      <Row>
        <Col span="18" offset="5">
          <ButtonGroup>
            <Button type="warning" @click="save">确定</Button>
          </ButtonGroup>
        </Col>
      </Row>
    </Form>
  </div>
</template>
<script>
export default {
  components: {},
  data() {
    return {
      cid: "",
      itemInput: "",
      colourGroup: this.$store.state.AddCommodity.colourGroup,
      sizeGroup: this.$store.state.AddCommodity.sizeGroup,
      barCodeList: []
    };
  },
  mounted: function() {
    //DOM更新完后再请求数据
    this.$nextTick(function() {
      this.colourGroup.forEach((item, index) => {
        this.sizeGroup.forEach((m, n) => {
          this.barCodeList.push({
            colorid: item.id,
            colorname: item.name,
            sizeid: m.id,
            sizename: m.name,
            dataCode: ""
          });
        });
      });
      this.barCodeList.forEach((item, index) => {
        item.dataCode = this.$store.state.AddCommodity.barCodeSetting[
          index
        ].dataCode;
      });
    });
  },
  created: function() {
    //DOM更新完之前请求数据
    let data = JSON.parse(localStorage.getItem("adminUser"));
    this.cid = data.cid;
  },
  methods: {
    changeBarcode(value){
      value.dataCode = value.dataCode.replace(/[\u4E00-\u9FA5]/g,'')
      value.dataCode = value.dataCode.replace(/:/g,'')
      value.dataCode = value.dataCode.replace(/：/g,'')
    },
    //保存save
    save() {
      var dataCodeArr = [];
      this.barCodeList.forEach((item, index) => {
        if (item.dataCode) {
          dataCodeArr.push(item.dataCode);
        }
      });
      // if((new Set(dataCodeArr)).size != dataCodeArr.length){
      //     this.$Message.warning("单品码不得重复");
      //     return
      // }
      this.$store.state.AddCommodity.allDrawer = false;
      this.$store.state.AddCommodity.barCodeSetting = this.barCodeList;
    }
  }
};
</script>


<style lang="scss" scoped>
</style>